export { default } from "./GeniusVocabularyContainer";
